<template>
  <div id="orderinfo" class="orderinfo userbox" v-loading.fullscreen="loading">
    <div class="userTitle">积分</div>
    <div class="pointTab">
      <div :class="pointTab==''?'on':''" @click="setTab('')">积分兑换</div>
      <div :class="pointTab==1?'on':''"  @click="setTab(1)">积分账单</div>
    </div>
    <div class="pointChange" v-if="pointTab==''">
      <img class="pointLogo" src="../../../static/images/icon/loading.svg" />
      <div class="nowPoint">当前积分: {{userInfo.PointsAll}}</div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item class="login_form_item" prop="ExchangeCode">
          <el-input class="login_ipt" v-model="ruleForm.ExchangeCode" placeholder="请输入您的兑换码" @input="setInput()">
          </el-input>
        </el-form-item>
          <!-- <el-form-item class="login_form_item" prop="Password">
            <el-input class="login_ipt" v-model="ruleForm.Password" placeholder="请输入你卡密" @input="setInput()">
            </el-input>
          </el-form-item> -->
        <el-button class="exchange_btn" :disabled='disabled' type="primary" @click="submitForm('ruleForm')">确认兑换</el-button>
      </el-form>
    </div>
    <div v-if="pointTab==1">
      <div v-if="!isNull&&list!=''">
        <div class="nowPoint">当前积分: {{userInfo.PointsAll}}</div>
        <div class="pointChangelist">
          <span class="pointName">标题</span>
          <span class="pointTime">日期</span>
          <span class="pointType">类型</span>
          <span class="pointPoint">积分</span>
        </div>
        <div>
          <div v-for="(item,index) in list" :key="index">
            <router-link class="pointChangelist" :to="{path:'/order/detail/'+item.OrderId}" v-if="item.OrderId!=null">
              <span class="pointName line_txt1">{{item.ExchangeCode}}</span>
              <span class="pointTime">{{item.CreateDate}}</span>
              <span class="pointType">{{item.Status>1?'消费':'充值'}}</span>
              <span class="pointPoint">{{item.Status>1?'-'+item.Score:'+'+item.Score}}</span>
            </router-link>
            <span class="pointChangelist" v-else>
              <span class="pointName line_txt1">{{item.ExchangeCode}}</span>
              <span class="pointTime">{{item.CreateDate}}</span>
              <span class="pointType">{{item.Status>1?'消费':'充值'}}</span>
              <span class="pointPoint">{{item.Status>1?'-'+item.Score:'+'+item.Score}}</span>
            </span>
          </div>
        </div>
        <pagination :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' />
      </div>
      <nonull type='order' text="暂无记录" v-if="isNull" />
    </div>
    <!-- <nonull type='order' text="未找到订单" v-if="isNull" /> -->
  </div>
</template>
<script>
import { getInfo,setInfo, numAdd, numSub, numMulti } from "@/api/public";
import Nonull from '@/components/nonull'
import Pagination from '@/components/pagination'
export default {
  name: 'pointchange',
  components: { Nonull,Pagination },
  data() {
    return {
      ps: 24, //pagesize
      pi: 1, //pageindex
      TotalCount: 0,
      isNull: false,
      loading: false,
      disabled: true,
      userInfo: getInfo(),
      list: '',
      pointTab: '', // 兑换:'',兑换记录:1
      ruleForm: {
        ExchangeCode: '',
        // Password: ''
      },
      rules: {
        ExchangeCode: [
          { required: true, message: '请输入正确兑换码', trigger: 'blur' },
        ],
        // Password: [
        //   { required: true, message: '请输入正确卡密', trigger: 'blur' },
        // ],
      },
    }
  },
  mounted() {

  },
  created() {
    this.GetMemberInfo()
  },
  methods: {

    setTab(val){
      this.pointTab=val;
      //this.GetMemberInfo()
      if(val==1){
        this.GetPointsList()
      }
    },
    GetMemberInfo(){
      let that=this;
      that.loading=true;
      let info=getInfo();
      let data={MemberId:info._id}
      that.$get(that.$interface.GetMemberInfoById,data).then(res=>{
        if(res.Result!=0){
          //newInfo
          setInfo('Level',res.Data.Level);
          setInfo('PointsAll',res.Data.PointsAll?res.Data.PointsAll:0);
          res.Data.PointsAll=res.Data.PointsAll?res.Data.PointsAll:0
          that.userInfo=res.Data;
        }else{
          that.$message.error(res.Msg);
        }
        that.loading=false
      }).catch({})
    },
    // 判断input是否有值
    setInput(val) {
      // console.log(this.ruleForm.Password,'this.ruleForm.Password')
      // console.log(this.ruleForm.ExchangeCode,'this.ruleForm.ExchangeCode')
      if ( this.ruleForm.ExchangeCode != '') {
        this.ruleForm.ExchangeCode= this.ruleForm.ExchangeCode.toUpperCase()
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    GetPointsList(){
      let that=this
      let info=getInfo();
      let data={MemberId:info._id,PageIndex:that.pi,PageSize:that.ps}
      that.$get(that.$interface.GetIntegralDetails,data).then(res=>{
        if(res.Result!=0){
          if(res.Count>0){
            that.isNull=false;
            that.list=res.Data
          }else{
            that.isNull=true;
          }
        }else{
            that.isNull=true;
              that.$message.error(res.Msg);
        }
      })
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      //this.getCommodityList()

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      //this.getCommodityList()
    },
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.ruleForm.MemberId=that.userInfo._id
          let data=that.ruleForm
          that.$post(that.$interface.PointsVerifyCode,data).then(res=>{
            if(res.Result!=0){
              that.$message.success('兑换成功');
              that.GetMemberInfo()
              that.setTab(1)
            }else{
              that.$message.error(res.Msg);
            }
          }).catch({})
          // this.IsExchange()
          // this.getAddress()
          // this.getOrdersList()
        }
      })
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/user.css";

</style>



// WEBPACK FOOTER //
// src/pages/user/point.vue